import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-business-rule',
  templateUrl: './business-rule.component.html',
  styleUrls: ['./business-rule.component.css']
})
export class BusinessRuleDialogComponent implements OnInit {
  form: FormGroup;

  units = ['m', 'cm', 'mm'];
  accuracyProperties = ['Low', 'Medium', 'High'];
businessRules = ['Rule 1', 'Rule 2', 'Rule 3'];

  constructor(private fb: FormBuilder,    public dialogRef: MatDialogRef<BusinessRuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { propertyName: string, propertyGroupName: string }) {}

  ngOnInit(): void {
this.form = this.fb.group({
  // accuracy: [null, Validators.required],
  // unit: [null, Validators.required],
  // accuracyProperty: [null, Validators.required],
    accuracy: [null],
  unit: [null],
  accuracyProperty: [null],
  customPattern: [''],
  businessRule: [null],
  mode: ['Assert'],
  businessRuleDescription: ['']
});


  }

  onClose() {
          console.log('Form values:', this.form.value);
    this.dialogRef.close();

    // if (this.form.valid) {
    //   console.log('Form values:', this.form.value);
    // }
  }

  onLock() {
    console.log('Cancelled');
        this.dialogRef.close();

  }
}
